import { connect } from 'react-redux'
import { HeaderComponent } from './HeaderComponent'
import type { Dispatch } from 'redux'
import type { EventMetadata } from 'shared/store/metadata'
import { eventMetadata } from 'shared/store/metadata'
import type { RootState } from 'shared/store/reducers'

const filterItemByPosition = (item, position) =>
    item.position && item.position.toUpperCase() === position

const desktopLeftItems = (items = []) => {
    return items.filter(item => filterItemByPosition(item, 'LEFT'))
}

const desktopRightItems = (items = []) => {
    return items.filter(item => filterItemByPosition(item, 'RIGHT'))
}

const mapStateToProps = (state: RootState) => {
    const { header, appInsertEnabled } = state.applicationState
    const { mainNavigationOpen } = state.uiState
    const { appBannerClosed } = state.userState

    return {
        desktopLeftItems: desktopLeftItems(header),
        desktopRightItems: desktopRightItems(header),
        location: state.router,
        open: mainNavigationOpen,
        showAppBanner: appInsertEnabled && !appBannerClosed
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    sendMeta: (meta: EventMetadata) => d(eventMetadata(meta))
})

const Header = connect(mapStateToProps, mapDispatchToProps)(HeaderComponent)

export { Header }
